import {AlphaLabel} from '@github-ui/lifecycle-labels/alpha'

import type {MarkdownViewMode} from '../types'
import styles from './Header.module.css'
import {ViewSwitch} from './ViewSwitch'

export interface HeaderProps {
  onChangeViewMode?: (view: MarkdownViewMode) => void
  selectedView?: MarkdownViewMode
  children?: React.ReactNode
  uploadInProgress?: boolean
}

/**
 * Header layout container.
 * Important: this is also rendered by error fallbacks so logic that might fail should be kept to an absolute minimum.
 */
export function Header({onChangeViewMode, selectedView = 'hybrid', children, uploadInProgress = false}: HeaderProps) {
  return (
    <div className={styles.header}>
      <div className={styles.content}>{children}</div>

      {/* Shipping publicly? Make sure to update the `ErrorFallback` messaging as well. */}
      <AlphaLabel />
      <ViewSwitch
        selectedView={selectedView}
        onViewSelect={onChangeViewMode}
        disabled={!onChangeViewMode || uploadInProgress}
      />
    </div>
  )
}

try{ Header.displayName ||= 'Header' } catch {}